var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(13 13.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 13,
    y: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6C9 2.113 6.81-.873 4.257.233 1.243 1.539 3.974 6 9 6zM9 6C9 2.113 11.19-.873 13.743.233 16.757 1.539 14.026 6 9 6zM9 6L9 19M0 10.256L18 10.256"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsIcon);
export default __webpack_public_path__ + "static/media/rewards-icon.674d4218.svg";
export { ForwardRef as ReactComponent };